// This file is generated by a script. Do not edit this file directly.
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from 'react';
export var Automation = function Automation(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 20 20"
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M13.342 1.25a.98.98 0 0 1 .944 1.251l-1.83 6.405h2.913a1.192 1.192 0 0 1 .773 2.102l-8.845 7.51a.98.98 0 0 1-1.58-1.019l1.83-6.405H4.593a1.153 1.153 0 0 1-.752-2.027l8.865-7.581a.97.97 0 0 1 .636-.236m-1.234 2.905L5.913 9.453h2.721c.257 0 .5.12.657.325a.8.8 0 0 1 .133.718l-1.532 5.366 6.264-5.315h-2.787c-.256 0-.499-.12-.656-.325a.8.8 0 0 1-.133-.718z"
  }));
};
